const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M47.3,47.3c-3.6,3.98-8.82,6.5-14.61,6.5-5.44,0-10.38-2.22-13.95-5.78-.19-.19-.38-.39-.56-.58-1.17.37-2.3.83-3.39,1.37-1.61.79-3.15,1.74-4.55,2.84-.88.67-1.71,1.42-2.5,2.2-4.77,4.78-7.72,11.38-7.72,18.66,0,2.3,1.86,4.16,4.16,4.16h57.5c1.15,0,2.19-.47,2.95-1.22.65-.65,1.09-1.52,1.2-2.5,0-.15.02-.3.02-.45,0-.85-.04-1.69-.13-2.52-.09-1.01-.24-2-.45-2.97-1.98-9.37-8.93-16.89-17.96-19.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,43.15c9.48,4.4,16.49,13.25,18.31,23.85h4.53c1.15,0,2.19-.47,2.94-1.22.75-.75,1.22-1.79,1.22-2.94,0-11.84-7.8-21.86-18.53-25.2-2.27,2.5-5.18,4.44-8.47,5.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.41,26.78v7.3c0,.81-.05,1.6-.15,2.39-.02.23-.05.46-.09.68.48-.21.94-.44,1.39-.68,1.31-.73,2.49-1.67,3.49-2.77.75-.82,1.4-1.73,1.93-2.72,1.06-1.95,1.66-4.18,1.66-6.54v-7.3c0-7.6-6.18-13.78-13.78-13.78-3.87,0-7.38,1.6-9.88,4.18,8.82,1.96,15.44,9.85,15.44,19.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.77,43.37c-.08,0-.16,0-.24.03.03.03.06.07.1.1.05-.06.09-.1.14-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.53,43.4c.08-.02.16-.03.24-.03-.05.03-.09.07-.14.13.97,1.04,2.11,1.92,3.37,2.62,1.98,1.11,4.26,1.73,6.68,1.73s4.71-.63,6.69-1.74c1.19-.66,2.26-1.49,3.19-2.45.11-.11.21-.21.31-.32.65-.71,1.23-1.5,1.71-2.34.08-.13.16-.26.23-.4.42-.77.77-1.6,1.03-2.46.18-.55.32-1.12.42-1.7.14-.77.21-1.57.21-2.39v-7.3c0-7.27-5.64-13.24-12.77-13.75-.34-.03-.67-.04-1.01-.04-.71,0-1.42.06-2.11.16-1.12.18-2.19.49-3.21.91-4.97,2.08-8.48,7-8.48,12.72v7.3c0,1.47.23,2.88.66,4.21.27.84.61,1.65,1.03,2.42.08.15.17.29.25.43.49.81,1.06,1.57,1.7,2.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8e1c09f7e906b9c69aedd02b9cc0b618.svg";
export { ForwardRef as ReactComponent };